import logo from './logo.svg';
import './App.css';
import { useEffect, useState } from 'react';
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry"
import useInfiniteScroll from 'react-infinite-scroll-hook';
import { useLoadItems } from './BskyLoader';
import { forwardRef } from 'react';
import { useSearchParams } from 'react-router';



function App( { imageObject, enabled, setIsFullscreen } ) {

    
 useEffect(() => {
    console.log("FullscreenImage props changed:", { imageObject, enabled });
 }, [imageObject, enabled]);


  return (

    ( enabled ) && (
    <div style={{ 
        position: "fixed", 
        top: 0, 
        left: 0, 
        width: "100%", 
        height: "100%", 
        backgroundColor: "rgba(0, 0, 0, 0.9)", 
        display: "flex", 
        justifyContent: "center", 
        alignItems: "center", 
        zIndex: 1000 
        }}
        onClick={() => {
            setIsFullscreen(false);
        }}>
        <img src={imageObject.src} alt="" style={{ maxWidth: "90%", maxHeight: "90%" }} />
        <div style={{ 
            position: "absolute", 
            bottom: "20px",
            color: "white",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            padding: "10px",
            borderRadius: "8px",
            maxWidth: "80%",
            textAlign: "center"
         }}
         >
            <a href={imageObject.postUrl} target="_blank" rel="noopener noreferrer">
            [Original Post] {imageObject.text}</a>
        </div>
    </div>
    )

  );
}

export default App;
